/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkCreateSystemUserResult } from './BulkCreateSystemUserResult';
import {
    BulkCreateSystemUserResultFromJSON,
    BulkCreateSystemUserResultFromJSONTyped,
    BulkCreateSystemUserResultToJSON,
    BulkCreateSystemUserResultToJSONTyped,
} from './BulkCreateSystemUserResult';

/**
 * 
 * @export
 * @interface BulkCreateSystemUsersResponse
 */
export interface BulkCreateSystemUsersResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkCreateSystemUsersResponse
     */
    createdCount: number;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateSystemUsersResponse
     */
    failedCount: number;
    /**
     * 
     * @type {Array<BulkCreateSystemUserResult>}
     * @memberof BulkCreateSystemUsersResponse
     */
    results: Array<BulkCreateSystemUserResult>;
}

/**
 * Check if a given object implements the BulkCreateSystemUsersResponse interface.
 */
export function instanceOfBulkCreateSystemUsersResponse(value: object): value is BulkCreateSystemUsersResponse {
    if (!('createdCount' in value) || value['createdCount'] === undefined) return false;
    if (!('failedCount' in value) || value['failedCount'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function BulkCreateSystemUsersResponseFromJSON(json: any): BulkCreateSystemUsersResponse {
    return BulkCreateSystemUsersResponseFromJSONTyped(json, false);
}

export function BulkCreateSystemUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreateSystemUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdCount': json['createdCount'],
        'failedCount': json['failedCount'],
        'results': ((json['results'] as Array<any>).map(BulkCreateSystemUserResultFromJSON)),
    };
}

export function BulkCreateSystemUsersResponseToJSON(json: any): BulkCreateSystemUsersResponse {
    return BulkCreateSystemUsersResponseToJSONTyped(json, false);
}

export function BulkCreateSystemUsersResponseToJSONTyped(value?: BulkCreateSystemUsersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdCount': value['createdCount'],
        'failedCount': value['failedCount'],
        'results': ((value['results'] as Array<any>).map(BulkCreateSystemUserResultToJSON)),
    };
}

